<aside id="sidebar_left" class="nano nano-light affix sidebar-default customer-menu" ng-show="!collapseMenuStatus">
    <div class="sidebar-left-content nano-content" tabindex="0">
        <ul class="nav sidebar-menu allMenu">

            <li ng-if="can('customer')" ng-class="{ active: isActive(['customer-orders'])}">
                <a href="/customer-orders">
                    <i class="icon-orders"></i>
                    <span class="sidebar-title">Orders</span>
                </a>
            </li>

            <li ng-if="can('customer')" ng-class="{ active: isActive(['customer-new-order'])}">
                <a href="/customer-new-order">
                    <i class="icon-add"></i>
                    <span class="sidebar-title">New Order</span>
                </a>
            </li>
            <!-- <li ng-if="can('customer')" ng-class="{ active: isActive(['customer-reports'])}">
                <a href="/customer-reports">
                    <span class="fa fa-line-chart"></span>
                    <span class="sidebar-title">Order Reports</span>
                    <span class="caret"></span>
                </a>
            </li> -->
            <li ng-if="can('customer')" ng-class="{ active: isActive(['live-orders'])}" ng-if="authenticatedUser.uber">
                <a href="/live-orders">
                    <span class="fa fa-line-chart"></span>
                    <span class="sidebar-title">Live Orders</span>
                </a>
            </li>
            <li ng-if="can('customer')" ng-class="{ active: isActive(['customer-check-orders'])}">
                <a href="/customer-check-orders">
                    <i class="icon-checklist"></i>
                    <span class="sidebar-title">Check List</span>
                </a>
            </li>
            <li ng-if="can('customer')" ng-class="{ active: isActive(['customer-billing'])}">
                <a href="/customer-billing">
                    <i class="icon-billing"></i>
                    <span class="sidebar-title">Billing</span>
                </a>
            </li>
            <li ng-if="can('customer')" ng-class="{ active: isActive(['customer-feedback'])}">
                <a href="/customer-feedback">
                    <i class="icon-feedback"></i>
                    <span class="sidebar-title">Feedback</span>
                </a>
            </li>
            <li ng-if="can('customer')" ng-class="{ active: isActive(['customer-reports'])}">
                <a href="/customer-reports">
                    <i class="fa fa-bar-chart"></i>
                    <span class="sidebar-title">Reports</span>
                </a>
            </li>
            <li ng-if="can('customer')" ng-class="{ active: isActive(['customer-settings'])}">
                <a href="/customer-settings">
                    <i class="icon-settings"></i>
                    <span class="sidebar-title">Settings</span>
                </a>
            </li>
            <li>
                <a href="#" ng-click="logout()">
                    <i class="icon-logout"></i>
                    <span class="sidebar-title">Log out</span>
                </a>
            </li>
        </ul>
    </div>
</aside>
